import React from 'react';
import { Mail, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = ({ language }) => {
  const texts = {
    en: {
      company: '365FullPull',
      tagline: 'Your access point for Souschaif',
      quickLinks: 'Quick Links',
      support: 'Support',
      legal: 'Legal',
      contact: 'Contact Us',
      address: 'Nassaukade, Amsterdam, The Netherlands',
      email: 'help@souschaif.com',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      cookies: 'Cookies',
      home: 'Home',
      features: 'Introduction',
      howItWorks: 'How It Works',
      benefits: 'Benefits',
      disclaimer: 'Ta storitev vključuje včlanitev v Souschaif. Prejeli boste osebni SMS na spletni strani ali z odgovorom in potrditvijo preko SMS se strinjate ter potrjujete uporabo storitev in prejemanje dostopa do neomejenih AI-generiranih receptov ter neomejenih AI kulinaričnih zahtevkov (AI requests). Cena storitve je 4,98 EUR na teden (2 SMS tedensko po 2,49 EUR z DDV). Od storitve se lahko odjavite s pošiljanjem STOP SOUS na 4433. Z aktivno naročnino prejmete neomejen dostop do receptov, prilagojenih vašim željam, sestavinam in prehranskim potrebam, ter možnost oddaje neomejenega števila AI zahtevkov za personalizirane kulinarične ideje. Storitev bo zaračunana na vašem mobilnem računu ali na vašem predplačniškem računu. Vaš aparat mora imeti omogočeno sprejemanje besedilnih sporočil ter prenos podatkov za dostop do digitalnih vsebin. Podjetje Souschaif ni povezano ali sponzorirano s strani proizvajalcev izdelkov, ki so omenjeni ali jih je mogoče videti v tej kampanji. Blagovne znamke, znamke storitev in logotipi so last njihovih izvornih lastnikov. Za uporabo storitev morate biti lastnik naročniškega razmerja ali pridobiti izrecno dovoljenje lastnika, v primeru mladoletnosti pa morate pridobiti izrecno dovoljenje staršev ali skrbnikov. Tehnični poslovni partner: Metanova. Za informacije pokličite 012373304 (Ponedeljek–Petek 09:00–17:00) ali pišite na help@amintabv.com. Aminta B.V., Stationstraat 28, 1382 AD, Weesp, Nizozemska.'
    },
    sl: {
      company: '365FullPull',
      tagline: 'Vaš dostop do Souschaif',
      quickLinks: 'Hitri linki',
      support: 'Podpora',
      legal: 'Pravno',
      contact: 'Kontaktirajte nas',
      address: 'Nassaukade, Amsterdam, Nizozemska',
      email: 'help@souschaif.com',
      rights: 'Vse pravice pridržane.',
      privacy: 'Pravilnik o zasebnosti',
      terms: 'Pogoji uporabe',
      cookies: 'Piškotki',
      home: 'Domov',
      features: 'Uvod',
      howItWorks: 'Kako deluje',
      benefits: 'Prednosti',
      disclaimer: 'Ta storitev vključuje včlanitev v Souschaif. Prejeli boste osebni SMS na spletni strani ali z odgovorom in potrditvijo preko SMS se strinjate ter potrjujete uporabo storitev in prejemanje dostopa do neomejenih AI-generiranih receptov ter neomejenih AI kulinaričnih zahtevkov (AI requests). Cena storitve je 4,98 EUR na teden (2 SMS tedensko po 2,49 EUR z DDV). Od storitve se lahko odjavite s pošiljanjem STOP SOUS na 4433. Z aktivno naročnino prejmete neomejen dostop do receptov, prilagojenih vašim željam, sestavinam in prehranskim potrebam, ter možnost oddaje neomejenega števila AI zahtevkov za personalizirane kulinarične ideje. Storitev bo zaračunana na vašem mobilnem računu ali na vašem predplačniškem računu. Vaš aparat mora imeti omogočeno sprejemanje besedilnih sporočil ter prenos podatkov za dostop do digitalnih vsebin. Podjetje Souschaif ni povezano ali sponzorirano s strani proizvajalcev izdelkov, ki so omenjeni ali jih je mogoče videti v tej kampanji. Blagovne znamke, znamke storitev in logotipi so last njihovih izvornih lastnikov. Za uporabo storitev morate biti lastnik naročniškega razmerja ali pridobiti izrecno dovoljenje lastnika, v primeru mladoletnosti pa morate pridobiti izrecno dovoljenje staršev ali skrbnikov. Tehnični poslovni partner: Metanova. Za informacije pokličite 012373304 (Ponedeljek–Petek 09:00–17:00) ali pišite na help@amintabv.com. Aminta B.V., Stationstraat 28, 1382 AD, Weesp, Nizozemska.'
    }
  };

  const t = texts[language];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-emerald-400">{t.company}</h3>
            <p className="text-gray-300">{t.tagline}</p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/souschaif" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://souschaif.com/" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200" aria-label="Souschaif updates">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/souschaif" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li><a href="#section-1" className="text-gray-300 hover:text-emerald-400 transition-colors duration-200">{t.home}</a></li>
              <li><a href="#section-2" className="text-gray-300 hover:text-emerald-400 transition-colors duration-200">{t.features}</a></li>
              <li><a href="#section-3" className="text-gray-300 hover:text-emerald-400 transition-colors duration-200">{t.howItWorks}</a></li>
              <li><a href="#section-4" className="text-gray-300 hover:text-emerald-400 transition-colors duration-200">{t.benefits}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">{t.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">{t.email}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="text-gray-400 text-xs leading-relaxed">
            <p className="mb-4">{t.disclaimer}</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              <p>© 2024 {t.company}. {t.rights}</p>
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy.html" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 text-sm">
                {t.privacy}
              </a>
              <a href="/terms.html" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 text-sm">
                {t.terms}
              </a>
              <a href="/privacy.html" className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 text-sm">
                {t.cookies}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
